import Mercado from '../components/mercado/Mercado';

// Proyectos: mercado primario y secundario en una sola pantalla (sin pantalla previa)
const Projectos = () => <Mercado />;

export default Projectos;
